import React from 'react'
import { Col, Row } from 'antd'

import CtaButton from 'components/CtaButton/CtaButton'
import LandingParagraph from 'components/LandingParagraph/LandingParagraph'
import ProfileCollectionSidescroll from 'components/ProfileCollectionSidescroll/ProfileCollectionSidescroll'
import Wrapper from 'components/Wrapper/Wrapper'

function LandingTextSection({ description, profileCollection, ctaButton }) {
  return (
    <Wrapper edgeToEdge>
      <Row>
        <Col xs={24} md={{ span: 20, offset: 2 }}>
          <LandingParagraph
            style={{
              textAlign: 'center',
              margin: '20px 20px 50px',
            }}
          >
            {description}
          </LandingParagraph>
        </Col>
        {profileCollection && (
          <Col span={24}>
            <ProfileCollectionSidescroll
              profileCollection={profileCollection}
              stripped
            />
          </Col>
        )}
        <Col span={24}>
          <div
            style={{
              textAlign: 'center',
              marginBottom: 20,
            }}
          >
            <CtaButton style={{ minWidth: 200 }}>
              <a href={ctaButton?.href}>{ctaButton?.text}</a>
            </CtaButton>
          </div>
        </Col>
      </Row>
    </Wrapper>
  )
}

export default LandingTextSection
